import { Entity, Field } from "typegraph";

import LaunchURL from "common/entities/LaunchURL";
import Product from "./Product";
import Subscription from "./Subscription";

@Entity({one: "entry", many: "entries"})
export default class Entry {

	@Field()
	public id: string;

	@Field({entity: Subscription})
	public subscription: Subscription;

	@Field({entity: LaunchURL})
	public launchURL: LaunchURL;

	@Field()
	public displayName: string;

	@Field({entity: Product})
	public product: Product;

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/entities/Entry.ts